module.exports = __webpack_public_path__ + "img/official.34221c4b.png";